import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass } from '../../../criteria/item-hdr-criteria.model';
import {ApiResponseModel, BasicApiResponseModel, PagingResponseModel} from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { CompanyContainerModel } from '../../../../../../models/aggregates/company';
import { ApiVisa } from '../../shared/api-visa.model';
import { CompanyCriteriaModelQuery } from "../../../criteria";
import { Observable } from "rxjs";
import { Pagination } from '../../shared/pagination.model';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseApiPublicLoginTemplateService<CompanyContainerModel, CompanyContainerModel, CompanyContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'companies/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.DOMAIN_URL_PREFIX + 'companies/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_login_url = Core2Config.DOMAIN_URL_PREFIX + 'companies/' + BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: ItemHdrQueryCriteriaClass
  ): Promise<PagingResponseModel<CompanyContainerModel>> {
    const buildDocCriteria = new CompanyCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<PagingResponseModel<CompanyContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  uploadCompanyLogo(visa: ApiVisa, file: File, companyHdrGuid: string, imageType?: string) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('files', file);
    }
    let url = visa.api_domain_url  + Core2Config.DOMAIN_URL_PREFIX + 'companies/add-files/backoffice-ep/' + companyHdrGuid;
    return this.httpClient.post(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  updateCompanyLogo(visa: ApiVisa, file: File, companyExtGuid: string) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    let url = visa.api_domain_url  + Core2Config.DOMAIN_URL_PREFIX + 'companies/replace-file/backoffice-ep/' + companyExtGuid;
    return this.httpClient.put(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  getFile(companyExtGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + companyExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + companyExtGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getFilePublic(companyExtGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/public/file/' + companyExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + companyExtGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  deleteFile(companyExtGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + companyExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + companyExtGuid;
    }

    return this.httpClient.delete<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getAllCompanyForAppletLoginEp(
    appletGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<CompanyContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<CompanyContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid,
      this.getHttpHeader(visa)
    );
  }

  public getCompanyByCriteriaForAppletLoginEp(
    appletGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<CompanyContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<CompanyContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getCompanyByGuidForAppletLoginEp(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<CompanyContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<CompanyContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  // will return multiple companies given multiple guids
  public getByMultipleGuidCriteria(
    guids: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<CompanyContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/query?hdr_guids="+guids;
    }
    return this.httpClient.get<ApiResponseModel<CompanyContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
